'use client'

import { Box } from "@mui/material";
import { styled } from '@mui/material/styles';

interface BorderGradientBoxProps {
    size: number | string;
}

const BorderGradientBox = styled(Box)<BorderGradientBoxProps>(({ theme, size }) => ({
    display: 'flex',
    width: '100%',
    height: '100%',
    borderStyle: 'solid',
    borderImageSlice: 1,
    borderWidth: size,
    borderImageSource: theme.palette.custom?.borderGradient,
}));

export default BorderGradientBox;